import _ from 'underscore';
import Promise from 'bluebird';

const errorObjectToString = (err) => {
  const { name, message, stack } = err;
  if (message || stack) {
    return `Error: ${name}, message: ${message}, stack: ${stack}`;
  }
  return JSON.stringify(err) || '(no error message)';
};

export const getErrorString = (err) => {
  if (!err) {
    return '';
  }

  if (_.isString(err)) {
    return err;
  }

  if (_.isObject(err)) {
    let msg = errorObjectToString(err);
    if (err.originError) {
      msg += `,\r\nOrigin ${errorObjectToString(err.originError)}`;
    }
    return msg;
  }

  return JSON.stringify(err);
};

export const getLogger = (activity, page = '', version = '', tag = 'Asset Library') => {
  const {
    trace, error, withSignalAsync, // perf, ajax,
  } = activity || {};

  const pageName = page;

  const logTrace = (...args) => {
    const [msg, params, ...rest] = args;
    if (trace) {
      const paramsJson = params ? ` $params: ${JSON.stringify(params)}` : '';
      trace(`[${tag}]${version ? `[${version}]` : ''}${page ? `[${page}]` : ''} ${msg}${paramsJson}`, ...rest);
    }
  };

  const logError = (...args) => {
    const [err, params, ...rest] = args;
    if (error) {
      const paramsJson = params ? ` $params: ${JSON.stringify(params)}` : '';
      const errMsg = getErrorString(err);
      error(`[${tag}] ${errMsg}${paramsJson}`, ...rest);
    }
  };

  const traceWithoutParams = (...args) => {
    const [msg, ...rest] = args;
    if (trace) {
      trace(`[${tag}] ${msg}`, ...rest);
    }
  };

  const monitorPromise = ({
    promise,
    msg,
    api,
  } = {}) => {
    if (withSignalAsync && promise) {
      withSignalAsync(new Promise((resolve) => {
        promise.then(() => { // we only record the success case
          resolve({
            message: `[${tag}] ${msg}`,
            api,
          });
        }).catch(() => { // tag the failed case with failed
          resolve({
            message: `[${tag}] ${msg}`,
            api: `${api}_failed`,
          });
        });
      }));
    }
    return promise;
  };

  return {
    pageName,
    logTrace,
    logError,
    traceWithoutParams,
    monitorPromise,
  };
};
